import { Button, Icon, Tooltip } from "@chakra-ui/react";
import { FiArrowLeft } from "react-icons/fi";
import { useNavigate } from "react-router";
import { SHARED_ROUTES } from "definitions/constants/routeConstants";
import useCaminoStore from "hooks/useCaminoStore";
import ROLE from "models/role";

interface ReturnToMainButtonProps {
  isExpanded: boolean;
}

export default function ReturnToMainButton({ isExpanded }: ReturnToMainButtonProps) {
  const navigate = useNavigate();
  const user = useCaminoStore((state) => state.currentUser);
  const credentialType = useCaminoStore((state) => state.credentialType);

  if (credentialType === "personal_email") return null;

  const hasElevatedRole = (user?.permission || []).some(
    (p) => p === ROLE.COMPANY_ADMIN || p === ROLE.PEOPLE_TEAM || p === ROLE.MANAGER,
  );
  if (!hasElevatedRole) return null;

  return (
    <Tooltip label="Return to main" isDisabled={isExpanded} placement="right">
      <Button
        width="100%"
        variant="tertiary"
        justifyContent={isExpanded ? "start" : "center"}
        size="xs"
        leftIcon={<Icon as={FiArrowLeft} boxSize="4" color="fg.subtle" />}
        onClick={() => navigate(SHARED_ROUTES.home)}
      >
        {isExpanded ? "Return to main" : ""}
      </Button>
    </Tooltip>
  );
}
